import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";

const JournalCard = ({ imgTitle, journalType, url }) => {
  return (
    <Fragment>
      <div className="flex flex-col md:flex-row gap-8 w-full md:w-10/12 lg:w-3/5 m-auto rounded-xl myShadow mt-12">
        <div>
          <img
            src={imgTitle}
            alt="Blog Post Title"
            className="h-full w-fit md:w-64 rounded-tr-xl rounded-tl-xl md:rounded-tl-xl md:rounded-bl-xl"
          />
        </div>
        <div className="md:w-2/3 w-full">
          <div className="px-4">
            <h3 className="md:mt-12 mt-4 text-2xl font-bold">
              The 360 Believer Journal - {journalType}
            </h3>
            <p className="mt-4 text-gray-600 text-justify">
              Our customized journal will come in handy to help you retain
              points from your personal Bible study, capture notes from your
              church service, maximize the teachings at special camp meetings,
              write down words of prophecies and even the ideas God has placed
              in your heart.
            </p>

            {/* Add to cart button */}
            <div className="mt-4">
              <p className="font-bold text-3xl mb-4"> ₦3,000 </p>
            </div>
            <div className="my-4">
              <NavLink to={url}>
                <button
                  className={`bg-dark-blue myShadow px-4 py-2 md:px-8 md:py-2.5 text-white hover:bg-none rounded-md disabled:opacity-50`}
                >
                  Select Item
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default JournalCard;
